require("dotenv").config();
import axios from "axios";

const apiURL = `${process.env.VUE_APP_TRANSLATIONS_APP_API_URL}/admin/user`;

class UserService {
  // Get all users
  static GetAllUsers(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios.post(`${apiURL}/get/all`, data).then(
              (response) => {
                return response.data;
              },
              (error) => {
                return error.response.data;
              }
            );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }

  // Update settings
  static UpdateSettings(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios.post(`${apiURL}/settings/update`, data).then(
              (response) => {
                return response.data;
              },
              (error) => {
                return error.response.data;
              }
            );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }
}

export default UserService;
